import { Flex } from '@chakra-ui/react'

import type { MessageOperatorV1MessageFragment } from '@/client/services/hasura/generated/graphql'

import RichText from '@/components/UI/RichTextEditor/RichText'

export default function MessageOperatorV1({
  message,
}: {
  message: MessageOperatorV1MessageFragment & {
    type: 'operator-announcement-v1' | 'operator-plain-v1'
  }
}): React.ReactElement {
  const styleProps =
    message.type === 'operator-announcement-v1'
      ? { color: 'fg', fontWeight: 'bold' }
      : { color: 'fg.subtle', fontStyle: 'italic' }

  return (
    <Flex flexDir="row" justifyContent="center" py="8px" color="fg.subtle">
      <RichText content={message.body_safe} styleProps={styleProps} />
    </Flex>
  )
}
